import React from 'react';
import styles from './index.module.scss';

const ArrowIcon: React.FC = () => {
  return (
    <svg
      width={10}
      height={8}
      className={styles.MuiSelectIco}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.058 7.705c-.049-.046-.255-.216-.425-.375C2.563 6.398.813 3.966.278 2.693.193 2.5.012 2.011 0 1.75c0-.25.06-.488.182-.716C.352.751.619.523.935.398c.22-.08.875-.205.887-.205C2.539.07 3.705 0 4.993 0 6.221 0 7.34.069 8.068.17c.011.012.826.137 1.105.273.51.25.827.74.827 1.262v.045c-.012.341-.33 1.057-.34 1.057-.536 1.204-2.2 3.58-3.306 4.534 0 0-.284.27-.462.386-.255.183-.57.273-.886.273-.353 0-.681-.102-.949-.295z"
        fill="#5F5577"
      />
    </svg>
  );
};

export default ArrowIcon;
